export default __webpack_public_path__ + "static/media/24.e6e73419.jpg";